import { useMemo } from 'react';

import { css, styled, TableSortLabel as MuiTableSortLabel } from '@mui/material';

import { TableSortAscIcon, TableSortDefaultIcon, TableSortDescIcon } from './TableSortIcon';

import type { TableSortLabelProps } from './types';

export default function TableSortLabel(props: TableSortLabelProps) {
  const { direction, active = true, ...others } = props;

  const IconComponent = useMemo(() => {
    if (direction === 'asc') return TableSortAscIcon;

    if (direction === 'desc') return TableSortDescIcon;

    return TableSortDefaultIcon;
  }, [direction]);

  return <TableSortLabelRoot IconComponent={IconComponent} active={active} {...others} />;
}

const TableSortLabelRoot = styled(MuiTableSortLabel)(
  ({ theme }) => css`
    & span:has(> svg) {
      position: relative;
    }
    ${theme.mixins.focusRing('outside', {
      selectors: {
        outline: '& span:has(> svg):before',
      },
    })}
  `,
);
